import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/reparation.service';



export const getNextNumReparation = createAsyncThunk(
    "Reparation/adm-getNextNum",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.getNextNum(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const listReparation = createAsyncThunk(
    "Reparation/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const listReparationReadySoon = createAsyncThunk(
    "Reparation/adm-listReadySoon",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.listReadySoon(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)
export const filterReparation = createAsyncThunk(
    "Reparation/adm-filter",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.filterAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewReparation = createAsyncThunk(
    "Reparation/adm-view",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.view(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createReparation = createAsyncThunk(
    "Reparation/adm-create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.create(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateReparation = createAsyncThunk(
    "Reparation/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.update(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteReparation = createAsyncThunk(
    "Reparation/adm-delete",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.remove(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const envoyerFbReparation = createAsyncThunk(
    "Reparation/adm-envoyerFb",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.envoyerFb(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const receptionnerFbReparation = createAsyncThunk(
    "Reparation/adm-receptionnerFB",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.receptionnerFB(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const envoyerMgReparation = createAsyncThunk(
    "Reparation/adm-envoyerMg",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.envoyerMg(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const receptionnerMgReparation = createAsyncThunk(
    "Reparation/adm-receptionnerMg",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.receptionnerMg(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const annulerReparation = createAsyncThunk(
    "Reparation/adm-annuler",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.annuler(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const mettrePretReparation = createAsyncThunk(
    "Reparation/adm-mettrePret",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.mettrePret(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)






const initialState = {
    loading: false,
    error: '',
    sel_Reparation: null
}

const ReparationSlice = createSlice({
    name: "Reparation",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },
        set_error: (state , action) => {
            state.error = action.payload
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = ReparationSlice;
export const { clear , set_error } = ReparationSlice.actions;
export default reducer;